module.exports = __webpack_public_path__ + "8d82a2b4f11806620bc63206fb1dbb88.woff";